import { render, staticRenderFns } from "./indexZh.vue?vue&type=template&id=1037357c&scoped=true&"
import script from "./indexZh.vue?vue&type=script&lang=js&"
export * from "./indexZh.vue?vue&type=script&lang=js&"
import style0 from "./indexZh.vue?vue&type=style&index=0&id=1037357c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1037357c",
  null
  
)

export default component.exports